import get from 'lodash/get'
import PropTypes from 'prop-types'

import getDisplayName from 'utils/getDisplayName'
import {
  GlobalIdTypes,
  fromGlobalId,
  toGlobalId,
} from 'utils/transformations/graphql'

export const getBrandIdFromLocation = (location = {}) => {
  const search = get(location, 'search', '')
  const params = new URLSearchParams(search)
  return params.get('brandId')
}

export const getAccounts = (props) => {
  const {
    isBrandUser,
    location,
    retailerAccount,
    accountId,
    brand,
    brandAccount,
    orderForRetailerId,
  } = props

  let retailerId
  let brandIdFormatted

  if (isBrandUser) {
    const plainRetailerId = retailerAccount
      ? fromGlobalId(retailerAccount.id).id
      : orderForRetailerId

    retailerId = plainRetailerId
      ? toGlobalId(GlobalIdTypes.Retailer, plainRetailerId)
      : ''
    brandIdFormatted = toGlobalId(GlobalIdTypes.Brand, accountId)
  } else {
    const brandIdFromLocation = getBrandIdFromLocation(location)

    if (brandAccount) {
      brandIdFormatted = brandAccount.id
    } else if (brandIdFromLocation) {
      brandIdFormatted = toGlobalId(GlobalIdTypes.Brand, brandIdFromLocation)
    } else {
      brandIdFormatted = toGlobalId(
        GlobalIdTypes.Brand,
        fromGlobalId(get(brand, 'id')).id,
      )
    }
    retailerId = toGlobalId(GlobalIdTypes.Retailer, accountId)
  }
  return {
    retailerAccount: {
      ...retailerAccount,
      id: retailerId,
    },
    brandAccount: {
      id: brandIdFormatted,
    },
  }
}

export const withAccountsFormatter = (WrappedComponent) => {
  const Wrapper = (props) => {
    const { retailerAccount, brandAccount } = getAccounts(props)
    const newProps = {
      ...props,
      retailerAccount,
      brandAccount,
    }
    return <WrappedComponent {...newProps} />
  }

  Wrapper.displayName = `withAccountsFormatter(${getDisplayName(
    WrappedComponent,
  )})`

  Wrapper.propTypes = {
    brandAccount: PropTypes.object,
    retailerAccount: PropTypes.object,
    accountId: PropTypes.number.isRequired,
    isBrandUser: PropTypes.bool.isRequired,
    location: PropTypes.object.isRequired,
    enableQuantifying: PropTypes.bool,
  }
  Wrapper.defaultProps = {
    brandAccount: null,
    retailerAccount: {},
    enableQuantifying: true,
  }
  return Wrapper
}

export default withAccountsFormatter
